import { useEffect, useState, useCallback } from "react";
import { Portal } from 'react-portal'
import { ShowAnimate } from "./ShowAnimate";
import EventEmitter from "eventemitter3";
import Icon from "../icon";

export type MsgType = "sucess" | "info" | "warning" | "error"

let emitter: EventEmitter = null as unknown as EventEmitter;

let timer: any = null

type Props = {
}

export function Message(props: Props) {
    let [show, setShow] = useState(false)
    const [type, settype] = useState<MsgType>("sucess");
    const [msg, setmsg] = useState<string>("");
    const [time, settime] = useState<number>(1.5);
    const [loaded, setloaded] = useState(false);

    const onMsg = (arg: { type: MsgType, msg: string, time?: number }) => {
        let { type, msg } = arg;
        settype(type);
        setmsg(msg);
        settime(time | 1.5)
        setTimer()
    }

    const clearTimer = useCallback(() => {
        timer && window.clearTimeout(timer)
        setShow(false)
    }, [setShow])

    const setTimer = useCallback(() => {
        clearTimer()
        setShow(true);
        timer = window.setTimeout(() => {
            clearTimer()
        }, time * 1000)
    }, [clearTimer, setShow, time])

    /* eslint-disable */
    useEffect(() => {
        setloaded(true);
        emitter = new EventEmitter();

        emitter.on("msg", onMsg);

        return () => {
            emitter.off("msg", onMsg)
        }
    }, [])

    let typeMap = {
        "sucess": {
            bg: "bg-[#F8FFEE] border-[#C5EB9D]",
            icon: <Icon className="rounded-full mt-1 flex justify-center items-center w-4 h-4 bg-[#72C040] leading-4 text-center flex-grow-0 text-white " fontSize={12} code="Check-lineicon" />
        },
        "info": {
            bg: "bg-[#E9F6FE] border-[#A7D8FE]",
            icon: <span className=" text-ms rounded-full mt-1 flex justify-center items-center w-4 h-4 bg-[#448EF7] leading-4 text-center flex-grow-0 text-white">i</span>
        },
        "warning": {
            bg: "bg-[#FEFBE8] border-[#FCE8A2]",
            icon: <span className=" text-ms rounded-full mt-1 flex justify-center items-center w-4 h-4 bg-[#EFB041] leading-4 text-center flex-grow-0 text-white">!</span>
        },
        "error": {
            bg: "bg-[#FDF2F0] border-[#F7CAC3]",
            icon: <Icon className="rounded-full mt-1 flex justify-center items-center w-4 h-4 bg-[#EC5B56] leading-4 text-center flex-grow-0 text-white " fontSize={12} code="Filledicon" />
        },
    }

    if (!loaded) return null;
    return <Portal>
        <div className=" z-[99999999999] fixed left-0 right-0 flex justify-center items-center top-5 md:top-24">
            <ShowAnimate show={show}>
                <div className={`${typeMap[type].bg}  border lg:w-[648px] px-4  py-2 flex  rounded `}>
                    <span className="  ">
                        {typeMap[type].icon}
                    </span>
                    <p className="flex-auto inline ml-2 text-base">
                        {msg}
                    </p>
                </div>
            </ShowAnimate>
        </div>
    </Portal>
}

export default async function message(msg: string, type: MsgType, time?: number) {
    emitter?.emit("msg", {
        type,
        msg,
        time
    });
} 
